import type { ReactNode } from "react"
import { Card, CardContent } from "@/components/ui/card"

interface ProgressStatCardProps {
  icon: ReactNode
  label: string
  value: string | number
  iconBgColor: string
}

export function ProgressStatCard({ icon, label, value, iconBgColor }: ProgressStatCardProps) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="p-6 flex items-center gap-6">
        <div className={`${iconBgColor} p-4 rounded-lg flex-shrink-0`}>{icon}</div>
        <div>
          <p className="text-sm text-slate-600">{label}</p>
          <p className="text-3xl font-bold text-slate-900">{value}</p>
        </div>
      </CardContent>
    </Card>
  )
}
